module.exports = __webpack_public_path__ + "f11f042dd5fd5d9f6daa802057171c98.warrior.png";


//////////////////
// WEBPACK FOOTER
// ./components/productVariants/rankPickers/mobileLegends/assets/warrior.png
// module id = fuv1
// module chunks = 0